var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6423 16.3305C21.9334 15.6649 22.0496 14.9399 21.9807 14.2202C21.9117 13.5005 21.6597 12.8085 21.2471 12.2062C20.8345 11.6039 20.2742 11.1099 19.6162 10.7685C18.9583 10.4271 18.2233 10.2488 17.4769 10.2497H16.3384C15.9696 8.84318 15.1584 7.58247 14.0172 6.64197C12.876 5.70147 11.4611 5.12768 9.96835 5M5.73068 5.87494C4.3194 6.63058 3.20959 7.8215 2.57781 9.25827C1.94603 10.695 1.82855 12.2951 2.24407 13.804C2.65959 15.3128 3.58424 16.6438 4.87093 17.5852C6.15762 18.5266 7.73245 19.0243 9.34489 18.9991H17.4769C18.0007 18.9985 18.5205 18.9097 19.0129 18.7366",
    stroke: "#F72B1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L22 22",
    stroke: "#F72B1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.143ee65d711feb47619dab9f6144dbc0.svg";
export { ForwardRef as ReactComponent };